import {
  FilterType,
  buildMandatoryProcessTasksFilter,
  useMandatoryProcessTasks,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

const options = () => [
  {
    label: i18n.t('processes.process.overview.filter.all'),
    value: 'all',
  },
  {
    label: i18n.t('processes.process.overview.filter.completed'),
    value: 'completed',
  },
  {
    label: i18n.t('processes.process.overview.filter.pending'),
    value: 'incompleted',
  },
  {
    label: i18n.t('processes.process.overview.filter.due_today'),
    value: 'due_today',
  },
  {
    label: i18n.t('processes.process.overview.filter.overdue'),
    value: 'over_due',
  },
  {
    label: i18n.t('processes.process.overview.filter.no_due'),
    value: 'no_due',
  },
]

export const statusFilter = (source: ReturnType<typeof useMandatoryProcessTasks>) =>
  buildMandatoryProcessTasksFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: options(),
      },
    ],
    identifier: 'processesTaskList.statusFilter',
    path: 'status',
    title: i18n.t('processes.process.overview.tasks_table.status'),
  })
